<template>
    <v-col class="d-flex py-0 pt-2">
        <p class="overline my-0 mr-1">IBAN</p>
        <p class="title flex-grow-0 mb-0 font-weight-bold">{{ recipientInfo.iban }}</p>
    </v-col>
</template>

<script>
    export default {
        name: "match-confirmed-reveal-field-iban",
        props: {
            recipientInfo: Object
        }
    }
</script>
